import PropTypes from 'prop-types';
import { formatDate } from 'Shared/util/formatters';
import styles from './invoice-timeline.css';


const getTimelinePosition = (point) => (point.exception ? styles.timelineBlockRight : styles.timelineBlockLeft);
const getMarkerColor = (point) => (point.serious ? styles.markerRed : styles.markerGreen);


const InvoiceTimeline = ({
  points,
}) => (
  <div className={styles.container}>
    {points.map((point, i) => (
      <div
        className={`${styles.timelineBlock} ${getTimelinePosition(point)}`}
        key={`${i + point.key}`}
      >
        <div className={`${styles.marker} ${point.fulfilled ? getMarkerColor(point) : ''}`} />
        <div className={styles.timelineContent}>
          <span>{point.key}</span>
          <span>{formatDate(point.date) || <>&nbsp;</>}</span>
        </div>
      </div>
    ))}
  </div>
);

InvoiceTimeline.propTypes = {
  points: PropTypes.array.isRequired,
};

export default InvoiceTimeline;
